import { AuthGuard, PermissionGuard } from '@abp/ng.core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetStateTypeComponent } from './components/asset-state-type.component';

const routes: Routes = [
  {
    path: '',
    component: AssetStateTypeComponent,
    canActivate: [AuthGuard, PermissionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssetStateTypeRoutingModule {}
